<template lang="pug">
	.audio-tracker-recorder--counter
		.counter-item.flex-row.align-center.center(v-for="item in items", :class="{ 'start': item.isStart }") {{item.value}}
</template>

<script>	
	export default {
		translationCategory: 'audioTracker.AudioTrackerRecorder',
		name: 'audio-tracker-recorder--counter',
		components: {},
		props: ['startPhrase', 'preventMetronome'],
		data() {
			return {
				count: 0,
				items: [],
				metronomeAudio: new Audio(require('@/assets/metronome.mp3'))
			};
		},
		computed: {			
		},
		watch: {			
		},
		mounted() {
			if (__DEBUG__)
				window.recorderCounter = this;				
		},
		methods: {
			start(count, handler) {
				this.count = count;
				this.showCountItem(handler);
			},
			showCountItem(handler) {
				if (this._isDestroyed) return;
				this.items = [];
				setImmediate(() => {
					this.items = [{ value: this.count }];
					if (this.count > 0) {
						setTimeout(() => this.showCountItem(handler), 1000);
						this.metronomeAudio.play();
					} else {
						this.items = [{ value: this.startPhrase || this.$tCaption('Start'), isStart: true }];
						this.metronomeAudio.play();
						if (handler)
							handler();
					}
					this.count--;
				});
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.audio-tracker-recorder--counter {		
		position: absolute;
		width: 100%;
		height: 100%;
		pointer-events: none;
		z-index: 1;

		.counter-item {
			--size: 100px;
			background: #fff;
			color: #333;
			width: var(--size);
			height: var(--size);
			border-radius: var(--size);
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translateX(-50%) translateY(-50%);
			padding: 40px;
			font-size: 40px;
			font-weight: 100;
			box-shadow: 0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14), 0 9px 46px 8px rgba(0,0,0,.12);
			animation: counter-anim 0.85s ease-in-out both;

			&.start {
				background: #1ea353;
				color: #b9edce;
			}
		}

		@keyframes counter-anim {
			0% {
				opacity: 0;
				transform: translateX(-50%) translateY(-50%) scale(0.5);
			}			
			25% {
				transform: translateX(-50%) translateY(-50%) scale(1);
				opacity: 1;
			}
			100% {
				opacity: 0;
				transform: translateX(-50%) translateY(-50%) scale(1);
			}
		}
	}
</style>
